export default __webpack_public_path__ + "static/media/ChippedTooth.73975dd0.mp3";